/**
 * Rotas do domínio Seguranca (T87, R5 e R7).
 *
 * Saiu de `src/router/rotas/Produto.ts` (hoje `src/views/Produto/produtoRotas.ts`, pela T106), recortada linha a linha: o `meta` veio
 * inteiro, inclusive `grupo: "Produto"` e `grupoTitle: "Produto"`. Isso não é
 * descuido — a tela de certificados de calibração aparece no menu **debaixo de
 * Produto**, e mudar o grupo mudaria a navegação do usuário, que é exatamente o
 * que R11 proíbe num PR de migração. O que mudou de lugar foi o arquivo; o hub
 * `views/Produto/produtoRotas.ts` (antes `router/rotas/Produto.ts`) passou a importar isto pelo barrel e a espalhar.
 *
 * `component` continua `() => import(...)` — a rota é lazy (R5), e é por isso
 * que publicar este array no barrel não põe a tela no grafo eager do boot.
 */

/** A rota de `/instrumentos`, espalhada pelo hub de Produto. */
export const rotaDeInstrumentos = [
  {
    path: "/instrumentos",
    name: "Certificados Calibração",
    component: () => import("@/views/Seguranca/SegurancaDashboardInstrumentos.vue"),
    meta: {
      breadcrumb: "",
      title: "Certificados Calibração",
      icon: "mdi-view-dashboard-outline",
      subject: ["TAF"],
      showMenu: true,
      grupo: "Produto",
      grupoTitle: "Produto",
    },
  },
];
